<div>
    <div class="col-12 fav-tile">
        <div class="tile-container">
            <div class="fav-tile-topNav">
                <div class="fav-tile-subNav">
                    <span class="fav-tile-veh-status mr tile-interstate"
                    *ngIf="checkVehStatusDesc(vehicleDetails)==='dealpending'"
                        [ngStyle]="{'background-color': checkVehStatusDesc(vehicleDetails) === '' ? 'white' : 'var(--airblue-500)' }">
                        <span class="tile-interstate">
                            {{getVehicleStatusdesc(vehicleDetails)}} </span>
                        <span 
                            [attr.aria-label]="'What is ' + getVehicleStatusdesc(vehicleDetails)">
                            <tooltip
                            [title]="getToolTipData(vehicleDetails, false)"
                            [description]="getToolTipData(vehicleDetails, true)"
                            [showTooltipdark]=false
                          ></tooltip>
                        </span>
                    </span>
                    <span class="fav-tile-veh-status tile-interstate"
                    *ngIf="checkReserved(vehicleDetails,false)==='reserve'"
                        [ngStyle]="{'background-color': checkReserved(vehicleDetails,false) === '' ? 'white' :  'var(--text-heading)' }">
                        <span class="tile-interstate">
                            {{checkReserved(vehicleDetails, true)}} </span>
                        <span 
                            [attr.aria-label]="'What is ' + getVehicleStatusdesc(vehicleDetails)">
                            <tooltip
                            [title]="getToolTipDataReserved(false)"
                            [description]="getToolTipDataReserved(true)"
                            [showTooltipdark]=false
                          ></tooltip>
                        </span>
                    </span>
                    <a href="javascript:void(0)" tabindex="0" (keypress)="removeFavorites(vehicleDetails);$event.stopPropagation()" class="heart-icon-link">
                        <span tabindex="0" role="button" [id]="'fav-tile-heart-'"
                        (click)="removeFavorites(vehicleDetails);$event.stopPropagation()"
                        class="heart-icon heart-off d-block" aria-label="Un favourite your vehicle">
                        <span class="dt-icon dt-icon-myfavorite-red-heart"></span>
                        
                    </span>
                </a>
                </div>
            </div>
            <div class="tile-img-info">
                <div class="tile-image">
                    <a tabindex="0" (click)="tealiumCallvehicleDetails(vehicleDetails.make + ' '+ vehicleDetails.model)" class="ad-button-focus" aria-label="open vehicle detail page"
                        [href]="tileLinkUrl(vehicleDetails)" >
                        
                        <img class="vehicle-img" fetchpriority="high"
                            [src]="'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVQYV2NgYAAAAAMAAWgmWQ0AAAAASUVORK5CYII='"
                            [lazyLoad]="calculatePhoto(vehicleDetails)"
                            [alt]="vehicleDetails.year + ' ' + vehicleDetails.make + ' ' + displayModel(vehicleDetails.model)" />
                    </a>
                </div>
            </div>
            <div class="fav-tile-car-detail-stack">
                <div class="fav-tile-car-detail-body">
                    <div class="fav-tile-car-make tile-interstate an-h-line-height">
                        {{vehicleDetails.make}}
                    </div>
                    <div class="fav-tile-car-model tile-interstate an-p-line-height">
                        {{displayModel(vehicleDetails.model)}}
                    </div>
                    <div>
                        <hr class="fav-car-tile-hr">
                    </div>
                    <div class="fav-tile-car-data">
                        <!-- For New VIN -->
                        <div class="fav-tile-car-make-year tile-interstate an-p-line-height"
                            [ngClass]="{'price-stack-width-highDemand': pricingStackView(vehicleDetails) === 2 || pricingStackView(vehicleDetails) === 4 || pricingStackView(vehicleDetails) === 3 || (pricingStackView(vehicleDetails) === 1 && isStockTypeNew(vehicleDetails))}"
                            *ngIf="isStockTypeNew(vehicleDetails)">
                            <div class="fav-tile-car-year tile-interstate">
                                {{vehicleDetails.year}}
                            </div>
                            <div class="fav-tile-car-period"></div>
                            <div class="fav-tile-car-stocktype tile-interstate">
                                {{vehicleDetails.stockType.toLowerCase() || ''}}
                            </div>
                        </div>

                        <!-- For Used VIN -->
                        <div class="fav-tile-car-make-year-used tile-interstate an-p-line-height" *ngIf="!isStockTypeNew(vehicleDetails)">
                            <div class="fav-tile-car-year-used tile-interstate">
                                {{vehicleDetails.year}}
                            </div>

                            <div class="fav-tile-car-stocktype tile-interstate">
                                {{vehicleDetails.stockType.toLowerCase() === 'cpo' ? 'CPO' :  vehicleDetails.stockType.toLowerCase() || ''}}
                            </div>
                            <div  class='cpo-tooltip' aria-label="certified tooltip" *ngIf="vehicleDetails.stockType.toLowerCase() === 'cpo'" >
                                <tooltip
                                [title]="'certified pre-owned'"
                                [description]="' '"
                                [showTooltipdark]=false
                                [showTooltipBlack]= true
                              ></tooltip>
                            </div>
                            <div class=" fav-tile-car-period"></div>
                            <div class="fav-tile-car-mileage tile-interstate">
                                {{formattedMileage(vehicleDetails.mileage)}} {{vehicleDetails.stockType.toLowerCase() === 'cpo' ? 'Mi.' : 'Miles'}}
                            </div>
                        </div>

                        <div class="fav-tile-car-price an-p-line-height"
                            [ngClass]="{'price-stack-width': pricingStackView(vehicleDetails) === 2 || pricingStackView(vehicleDetails) === 4 || pricingStackView(vehicleDetails) === 3 || (pricingStackView(vehicleDetails) === 1 && isStockTypeNew(vehicleDetails)) }">
                             <!-- Pricing Stack MSRP -->
                             <div class="fav-car-tile-new tile-interstate" *ngIf="pricingStackView(vehicleDetails) === 0">
                                {{getPrice(vehicleDetails) | currency:'USD':'symbol':'1.0-0'}} &nbsp;
                                <span class="fav-car-tile-msrp">
                                    {{getName(vehicleDetails)}}
                                </span>
                            </div>
                            
                            <!-- Pricing Stack ANB Price -->
                            <div class="fav-car-tile-used" *ngIf="pricingStackView(vehicleDetails) === 1">
                                <div class="fav-car-tile-msrp-value tile-interstate" >
                                    {{getPrice(vehicleDetails) | currency:'USD':'symbol':'1.0-0'}}&nbsp;
                                </div>
                                <div class="fav-car-tile-msrp tile-interstate" *ngIf="isStockTypeNew(vehicleDetails)">
                                    {{getName(vehicleDetails)}}
                                </div>
                                    <span class="dt-icon dt-icon-myfavorite-1price" *ngIf="!isStockTypeNew(vehicleDetails)"></span>
                                    <div  aria-label="What is the price" *ngIf="!isStockTypeNew(vehicleDetails)" >
                                        <tooltip
                                        [title]="getToolTipData(vehicleDetails, false, true)"
                                        [description]="getToolTipData(vehicleDetails, true, true)"
                                        [showTooltipdark]=true
                                      ></tooltip>
                                    </div>
                            </div>

                            <!-- Pricing Stack High Demand -->
                            <div class="fav-car-tile-highDemand" *ngIf="pricingStackView(vehicleDetails) === 2 || pricingStackView(vehicleDetails) === 4">
                                <div class="store-name tile-interstate">{{stateData.callForPrice || 'Call for Price'}}</div> &nbsp;
                                <div class="store-phone-number"><a class="store-phone tile-interstate" href="tel:StoreDetail.Phone" tabindex="0">{{vehicleDetails.StoreDetail.Phone || ''}}</a></div>

                            </div>
                            <!-- Pricing Stack Pending Sale -->
                            <div class="fav-car-tile-highDemand" *ngIf="pricingStackView(vehicleDetails) === 3">
                                <div class="store-name tile-interstate">{{stateData.pendingSale || 'Pending Sale'}}</div> &nbsp;
                                <div class="store-phone-number"><a class="store-phone tile-interstate" href="tel:StoreDetail.Phone" tabindex="0">{{vehicleDetails.StoreDetail.Phone || ''}}</a></div>
                            </div>

                        </div>
                    </div>

                </div>

            </div>
        </div>
    </div>
</div>